import { RequestStatus } from '../../enums';
import { makeAsyncReducerHandlers } from '../../helpers';
import { PromptsActionTypes } from '../../actions/types';

const getPrompts = makeAsyncReducerHandlers(
  PromptsActionTypes.getPrompts,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => ({
    items: action.payload.prompts,
    status: RequestStatus.SUCCEEDED,
    error: null,
  }),
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

const savePrompt = makeAsyncReducerHandlers(
  PromptsActionTypes.savePrompt,
  (state, action) => ({
    items: state.items,
    status: RequestStatus.LOADING,
    error: null,
  }),
  (state, action) => {
    const { prompt } = action.payload;
    const index = state.items.reduce((acc, p, i) => {
      if (p._id === prompt._id) return i;
      return acc;
    }, -1);
    state.items[index] = prompt;

    return {
      items: state.items,
      status: RequestStatus.SUCCEEDED,
      error: null,
    };
  },
  (state, action) => ({
    items: state.items,
    status: RequestStatus.FAILED,
    error: action.error,
  }),
);

export default {
  getPrompts,
  savePrompt,
};
